export interface DeviceSummary {
  label: string;
  mobile: boolean;
}

/** Resume o user-agent em "Navegador no Sistema" (sem expor a string inteira). */
export function summarizeUserAgent(ua: string | null | undefined): DeviceSummary {
  if (!ua) return { label: 'Dispositivo desconhecido', mobile: false };
  const browser = /Edg(e|A|iOS)?\//.test(ua)
    ? 'Edge'
    : /OPR\/|Opera/.test(ua)
      ? 'Opera'
      : /SamsungBrowser/.test(ua)
        ? 'Samsung Internet'
        : /Firefox\/|FxiOS/.test(ua)
          ? 'Firefox'
          : /Chrome\/|CriOS/.test(ua)
            ? 'Chrome'
            : /Safari\//.test(ua)
              ? 'Safari'
              : null;
  const os = /Windows/.test(ua)
    ? 'Windows'
    : /Android/.test(ua)
      ? 'Android'
      : /iPhone|iPad|iPod/.test(ua)
        ? 'iOS'
        : /Mac OS X|Macintosh/.test(ua)
          ? 'macOS'
          : /CrOS/.test(ua)
            ? 'ChromeOS'
            : /Linux/.test(ua)
              ? 'Linux'
              : null;
  const mobile = /Mobile|iPhone|iPod/.test(ua);
  if (!browser && !os) return { label: 'Dispositivo desconhecido', mobile };
  return { label: browser && os ? `${browser} no ${os}` : (browser ?? os ?? ''), mobile };
}

const RTF = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

/** "agora mesmo", "há 5 minutos", "ontem"... */
export function relativeTime(iso: string, now = Date.now()): string {
  const diff = (new Date(iso).getTime() - now) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return 'agora mesmo';
  if (abs < 3600) return RTF.format(Math.round(diff / 60), 'minute');
  if (abs < 86_400) return RTF.format(Math.round(diff / 3600), 'hour');
  return RTF.format(Math.round(diff / 86_400), 'day');
}
